<pp-advanced-filter-option-select
  class="advancedFilter__option"
  [ppItems]="advancedFilterPercentageOptions"
  [ppOption]="option"
  (ppOptionChange)="changeFieldCondition($event)"
  ppClass="advancedFilter__option--condition"
  ppWidth="210"
/>

@if (
  option === EAdvancedFilterOptions.IS ||
  option === EAdvancedFilterOptions.IS_NOT ||
  option === EAdvancedFilterOptions.IS_LESS_THAN ||
  option === EAdvancedFilterOptions.IS_GREATER_THAN ||
  option === EAdvancedFilterOptions.IS_GREATER_THAN_OR_EQUAL ||
  option === EAdvancedFilterOptions.IS_LESS_THAN_OR_EQUAL
) {
  <pp-advanced-filter-number-input
    ppUnit="%"
    [ppDecimalPlaces]="0"
    [(ppValue)]="value"
    (ppValueChange)="changeFieldValue($event)"
    [ppShowCommas]="showCommas"
  />
}
